module.exports = __webpack_public_path__ + "static/media/SWSCRC1-39.17f82417.mp3";